import visibilidad from "../lib/visibilidad";

const mapa = async () => {
    const contenedor = document.querySelector<HTMLElement>('#mapa');

    if (!contenedor) {
        return;
    }

    (window as any).initMap = async () => {
        const {Marker} = await google.maps.importLibrary("marker");

        const ubicaciones = window.ubicaciones;

        const map = new google.maps.Map(contenedor, {
            disableDefaultUI: true,
            center: ubicaciones[0],
            zoom: 16
        });

        ubicaciones.forEach((ubicacion) => {
            new Marker({
                position: ubicacion,
                map: map,
            });
        });

        if (ubicaciones.length > 1) {
            const bound = new google.maps.LatLngBounds();
            ubicaciones.forEach(centro => bound.extend(new google.maps.LatLng(centro.lat, centro.lng)));
            map.fitBounds(bound);
        }
    }

    visibilidad(() => {
        const script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=$key&callback=initMap&libraries=geometry'.replace('$key', (window as any).googleMapsKey);
        document.head.appendChild(script);
    }, contenedor);

    const tour = document.querySelector<HTMLElement>('.mapa__tour');
    if (tour) {
        visibilidad(x => x.innerHTML = x.dataset.iframe!, tour);
    }
}


export default mapa;